const Title = ({ title, subtitle }: { title: string; subtitle?: string }) => {
    return (
        <div className="flex flex-col">
            <h1 className="text-2xl font-bold text-gray-900 leading-tight">{title}</h1>
            {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
        </div>
    );
};

export default Title;